import { Dispatch } from 'redux';
import { api } from "../config/api";
import { GetState } from "../config/store";
import {
    getFiltersRequest,
    getFiltersSuccess,
    getFiltersFailure,
    getDealershipsRequest,
    getDealershipsSuccess,
    getDealershipsFailure,
    getBrandsRequest,
    getBrandsSuccess,
    getBrandsFailure,
    getModelsRequest,
    getModelsSuccess,
    getModelsFailure,
    getColorRequest,
    getColorSuccess,
    getColorFailure,
    getFuelRequest,
    getFuelSuccess,
    getFuelFailure,
    getRegionsRequest,
    getRegionsSuccess,
    getRegionsFailure,
    getTransmissionRequest,
    getTransmissionSuccess,
    getTransmissionFailure,
    getYearsRequest,
    getYearsSuccess,
    getYearsFailure,
    getTypeCarRequest,
    getTypeCarSuccess,
    getTypeCarFailure,
    updateModels,
    setBrand,
    setModel,
    setYear,
    setVehicleType,
    setPrice,
    setMileage,
    setColor,
    setFuel,
    setType,
    setRegion,
    setTransmission,
    setVehicleCategory,
    cleanFilters,
    setPage as setPageReducer
} from '../reducers/filters';
import { axiosClient } from '../config/axios';

export const getFiltersAll = (condition?: 'used' | 'new') => (dispatch: Dispatch) => _getFiltersAll(dispatch, condition);
const _getFiltersAll = async (dispatch: Dispatch, condition?: 'used' | 'new') => {
    try {
        dispatch({ type: getFiltersRequest });
        // Load all necessary filters for home page
        const brands = await getBrands(condition)(dispatch);
        const dealerships = await getDealerships(condition)(dispatch);
        const colors = await getColor(condition)(dispatch);
        const fuels = await getFuel(condition)(dispatch);
        const years = await getYears(condition)(dispatch);
        // const types = await getTypeCar(condition)(dispatch);
        const transmissions = await getTransmission(condition)(dispatch);
        const regions = await getRegions(condition)(dispatch);

        if (brands && dealerships && colors && fuels && years && transmissions && regions) {
            dispatch({ type: getFiltersSuccess });
        }
    } catch (error: any) {
        dispatch({ type: getFiltersFailure });
    }
};

export const getBrands = (condition?: 'used' | 'new') => (dispatch: Dispatch) => _getBrands(dispatch, condition);
const _getBrands = async (dispatch: Dispatch, condition?: 'used' | 'new') => {
    try {
        dispatch({ type: getBrandsRequest });

        let url = `${api.search}/brands`;

        if (condition) {
            url += `?condition=${condition}`;
        }

        const response = await axiosClient.get(url);

        dispatch({ type: getBrandsSuccess, payload: response?.data });

        return response?.data;

    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse);
        dispatch({ type: getBrandsFailure });
    }
}

export const getModels = (brandName: string, condition?: 'used' | 'new') => (dispatch: Dispatch) => _getModels(dispatch, brandName, condition);
const _getModels = async (dispatch: Dispatch, brandName: string, condition?: 'used' | 'new') => {
    try {
        dispatch({ type: getModelsRequest });

        let url = `${api.search}/models/brand/${brandName}`;

        if (condition) {
            url += `?condition=${condition}`;
        }

        const response = await axiosClient.get(url);

        dispatch({ type: getModelsSuccess, payload: response?.data });

        return response?.data;

    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse);
        dispatch({ type: getModelsFailure });
    }
}

export const getColor = (condition?: 'used' | 'new') => (dispatch: Dispatch) => _getColor(dispatch, condition);
const _getColor = async (dispatch: Dispatch, condition?: 'used' | 'new') => {
    try {
        dispatch({ type: getColorRequest });

        let url = `${api.search}/colors`;

        if (condition) {
            url += `?condition=${condition}`;
        }

        const response = await axiosClient.get(url);

        dispatch({ type: getColorSuccess, payload: response?.data });

        return response?.data;

    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse);
        dispatch({ type: getColorFailure });
    }
}

export const getFuel = (condition?: 'used' | 'new') => (dispatch: Dispatch) => _getFuel(dispatch, condition);
const _getFuel = async (dispatch: Dispatch, condition?: 'used' | 'new') => {
    try {
        dispatch({ type: getFuelRequest });

        let url = `${api.search}/fuels`;

        if (condition) {
            url += `?condition=${condition}`;
        }

        const response = await axiosClient.get(url);

        dispatch({ type: getFuelSuccess, payload: response?.data });

        return response?.data;

    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse);
        dispatch({ type: getFuelFailure });
    }
}

export const getRegions = (condition?: 'used' | 'new') => (dispatch: Dispatch) => _getRegions(dispatch, condition);
const _getRegions = async (dispatch: Dispatch, condition?: 'used' | 'new') => {
    try {
        dispatch({ type: getRegionsRequest });

        let url = `${api.search}/regions`;

        if (condition) {
            url += `?condition=${condition}`;
        }
        const response = await axiosClient.get(url);

        dispatch({ type: getRegionsSuccess, payload: response?.data });

        return response?.data;

    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse);
        dispatch({ type: getRegionsFailure });
    }
}

export const getDealerships = (condition?: 'used' | 'new') => (dispatch: Dispatch) => _getDealerships(dispatch, condition);
const _getDealerships = async (dispatch: Dispatch, condition?: 'used' | 'new') => {
    try {
        dispatch({ type: getDealershipsRequest });

        let url = `${api.search}/dealerships`;

        if (condition) {
            url += `?condition=${condition}`;
        }

        const response = await axiosClient.get(url);

        dispatch({ type: getDealershipsSuccess, payload: response?.data?.data });

        return response?.data?.data;

    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse);
        dispatch({ type: getDealershipsFailure });
    }
}

export const getTransmission = (condition?: 'used' | 'new') => (dispatch: Dispatch) => _getTransmission(dispatch, condition);
const _getTransmission = async (dispatch: Dispatch, condition?: 'used' | 'new') => {
    try {
        dispatch({ type: getTransmissionRequest });


        let url = `${api.search}/transmissions`;

        if (condition) {
            url += `?condition=${condition}`;
        }

        const response = await axiosClient.get(url);

        dispatch({ type: getTransmissionSuccess, payload: response?.data });

        return response?.data;

    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse);
        dispatch({ type: getTransmissionFailure });
    }
}

export const getYears = (condition?: 'used' | 'new') => (dispatch: Dispatch) => _getYears(dispatch, condition);
const _getYears = async (dispatch: Dispatch, condition?: 'used' | 'new') => {
    try {
        dispatch({ type: getYearsRequest });

        let url = `${api.search}/years`;

        const params: string[] = [];

        if (condition) params.push(`condition=${condition}`);

        if (params.length) {
            url += `?${params.join('&')}`;
        }

        const response = await axiosClient.get(url);

        dispatch({ type: getYearsSuccess, payload: response?.data });

        return response?.data;

    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse);
        dispatch({ type: getYearsFailure });
    }
}

export const getTypeCar = (typeArticle?: 'vehicles' | 'trucks', condition?: 'used' | 'new',) => (dispatch: Dispatch) => _getTypeCar(dispatch, typeArticle, condition);
const _getTypeCar = async (dispatch: Dispatch, typeArticle?: 'vehicles' | 'trucks', condition?: 'used' | 'new',) => {
    try {
        dispatch({ type: getTypeCarRequest });

        let url = `${api.search}/types`;

        const params: string[] = [];

        if (typeArticle) params.push(`type_articles=${typeArticle}`);
        if (condition) params.push(`condition=${condition}`);

        if (params.length) {
            url += `?${params.join('&')}`;
        }
        const response = await axiosClient.get(url);

        dispatch({ type: getTypeCarSuccess, payload: response?.data });

        return response?.data;

    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse);
        dispatch({ type: getTypeCarFailure });
    }
}

export const cleanFiltersAll = () => (dispatch: Dispatch) => _cleanFiltersAll(dispatch);
const _cleanFiltersAll = (dispatch: Dispatch) => dispatch({ type: cleanFilters });

// Setters
export const updateModelsReducer = (models: any[]) => (dispatch: Dispatch) => _updateModelsReducer(models, dispatch);
const _updateModelsReducer = (models: any[], dispatch: Dispatch) => dispatch({ type: updateModels, payload: models });

export const setBrandReducer = (brand: any[]) => (dispatch: Dispatch) => _setBrandReducer(brand, dispatch);
const _setBrandReducer = (brand: any[], dispatch: Dispatch) => dispatch({ type: setBrand, payload: brand });

export const setModelReducer = (model: any[]) => (dispatch: Dispatch) => _setModelReducer(model, dispatch);
const _setModelReducer = (model: any[], dispatch: Dispatch) => dispatch({ type: setModel, payload: model });


export const setRegionReducer = (region: string[]) => (dispatch: Dispatch) => _setRegionReducer(region, dispatch);
const _setRegionReducer = (region: string[], dispatch: Dispatch) => dispatch({ type: setRegion, payload: region });

export const setTransmissionReducer = (transmission: string[]) => (dispatch: Dispatch) => _setTransmissionReducer(transmission, dispatch);
const _setTransmissionReducer = (transmission: string[], dispatch: Dispatch) => dispatch({ type: setTransmission, payload: transmission });

export const setYearReducer = (year: string[]) => (dispatch: Dispatch) => _setYearReducer(year, dispatch);
const _setYearReducer = (year: string[], dispatch: Dispatch) => dispatch({ type: setYear, payload: year });

export const setPriceReducer = (min: string, max: string) => (dispatch: Dispatch) => _setPriceReducer(min, max, dispatch);
const _setPriceReducer = (min: string, max: string, dispatch: Dispatch) => dispatch({ type: setPrice, payload: { min, max } });

export const setMileageReducer = (mileage: any[]) => (dispatch: Dispatch) => _setMileageReducer(mileage, dispatch);
const _setMileageReducer = (mileage: any[], dispatch: Dispatch) => dispatch({ type: setMileage, payload: mileage });

export const setColorReducer = (color: string[]) => (dispatch: Dispatch) => _setColorReducer(color, dispatch);
const _setColorReducer = (color: string[], dispatch: Dispatch) => dispatch({ type: setColor, payload: color });

export const setFuelReducer = (fuel: string[]) => (dispatch: Dispatch) => _setFuelReducer(fuel, dispatch);
const _setFuelReducer = (fuel: string[], dispatch: Dispatch) => dispatch({ type: setFuel, payload: fuel });

export const setTypeReducer = (type: string[]) => (dispatch: Dispatch) => _setTypeReducer(type, dispatch);
const _setTypeReducer = (type: string[], dispatch: Dispatch) => dispatch({ type: setType, payload: type });

export const setVehicleTypeReducer = (vehicleType: string) => (dispatch: Dispatch) => _setVehicleTypeReducer(vehicleType, dispatch);
const _setVehicleTypeReducer = (vehicleType: string, dispatch: Dispatch) => dispatch({ type: setVehicleType, payload: vehicleType });

export const setVehicleCategoryReducer = (vehicleCategory: string[]) => (dispatch: Dispatch) => _setVehicleCategoryReducer(vehicleCategory, dispatch);
const _setVehicleCategoryReducer = (vehicleCategory: string[], dispatch: Dispatch) => dispatch({ type: setVehicleCategory, payload: vehicleCategory });

export const setPage = (page: number) => (dispatch: Dispatch) => _setPage(page, dispatch);
const _setPage = (page: number, dispatch: Dispatch) => dispatch({ type: setPageReducer.type, payload: page });
